import React from 'react';
import {Link} from 'react-router-dom';
function  Error(){
    return (
        <div>
            <h1>
                ERROR: WEBPAGE NOT FOUND
            </h1>
            <p>
            <Link to="/">
                    Back to Home Page
            </Link>
            </p>
        </div>
    )
}

export default Error;